(function(app) {
    app.provider("pipelineApi",
    [
        function() {
            this.$get = [
                "crmApiGateway", function(crmApiGateway) {
                    var service = {};

                    //GETs
                    service.get = function(pipelineId) {
                        return crmApiGateway.get("/SalesPipelines/" + pipelineId);
                    };

                    service.getCurrentUserPipelines = function() {
                        return crmApiGateway.getArray("/Me/SalesPipelines");
                    };

                    service.getCurrentUserPipelineSummary = function () {
                        return crmApiGateway.getArray("/Me/Summary");
                    };

                    service.getPipe = function(pipelineId, pipeId) {
                        return crmApiGateway.get("/SalesPipelines/" + pipelineId + "/Pipes/" + pipeId);
                    };

                    service.getPipes = function(pipelineId) {
                        return crmApiGateway.getArray("/SalesPipelines/" + pipelineId + "/Pipes");
                    };

                    //PUTs
                    service.update = function(pipeline) {
                        return crmApiGateway.put("/SalesPipelines/" + pipeline.Id, pipeline);
                    };

                    service.updatePipe = function(pipelineId, pipeId, pipe) {
                        return crmApiGateway.put("/SalesPipelines/" + pipelineId + "/Pipes/" + pipeId, pipe);
                    };

                    //POSTs
                    service.add = function(pipeline) {
                        return crmApiGateway.post("/SalesPipelines", pipeline);
                    };

                    service.addPipe = function(pipelineId, pipe) {
                        return crmApiGateway.post("/SalesPipelines/" + pipelineId + "/Pipes", pipe);
                    };

                    //DELETEs
                    service.delete = function(pipelineId) {
                        return crmApiGateway.delete("/SalesPipelines/" + pipelineId);
                    }

                    service.removePipe = function(pipelineId, pipeId) {
                        return crmApiGateway.delete("/SalesPipelines/" + pipelineId + "/Pipes/" + pipeId);
                    }

                    return service;
                }
            ];
        }
    ]);

})(window.app); // jshint ignore: line